<template>
  <vc-date-picker class="inline-block" ref="datePicker" v-model="date" :masks="masks" :disabled="readonly" :min-date="minDate" :max-date="maxDate" :update-on-input="true" @dayclick="updateDate">
    <template v-slot="{ inputValue, togglePopover, showPopover, inputEvents }">
      <div class="flex items-center relative">
        <vs-input
          class="vsinput w-full"
          v-model="inputValue"
          :readonly="readonly"
          @click="!readonly ? showPopover({ placement: 'auto-start' }) : temp()"
          :placeholder="placeholder"
          :class="readonly || 'none-readonly-input'"
          @input="debouncedHandleInput"
          @focusout="onFocusout"
        />
        <vs-icon
          v-if="!readonly && !inputValue"
          icon-pack="feather"
          icon="icon-calendar"
          style="
            color: #3c3c3c;
            margin-top: 6px;
            margin-bottom: 6px;
            margin-right: 1px;
            padding-left: 6px;
            padding-right: 6px;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            font-size: 24px;
            border-left: 1px solid #cdcdcd;
            background-color: #fff;
          "
          class="cursor-pointer"
          @click="!readonly ? togglePopover({ placement: 'auto-start' }) : temp()"
        ></vs-icon>
        <vs-icon
          v-if="!readonly && inputValue"
          icon-pack="feather"
          icon="icon-x"
          style="
            color: #3c3c3c;
            margin-top: 6px;
            margin-bottom: 6px;
            margin-right: 1px;
            padding-left: 6px;
            padding-right: 6px;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            font-size: 24px;
            border-left: 1px solid #cdcdcd;
            background-color: #fff;
          "
          class="cursor-pointer"
          @click="!readonly && clickXIcon()"
        ></vs-icon>
      </div>
    </template>
  </vc-date-picker>
</template>

<script>
// https://v2.vcalendar.io/
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";

export default {
  name: "DateSelector",
  components: {
    Datepicker,
  },
  props: {
    value: { type: String, default: "" },
    division: { type: String, default: "-" },
    format: { type: String, default: "YYYY-MM-DD" },
    minimumView: { type: String, default: "day" },
    maximumView: { type: String, default: "year" },
    minDate: { type: String, default: "" },
    maxDate: { type: String, default: "" },
    readonly: Boolean,
    placeholder: String,
    // 디바운스 시간
    debounceMs: {
      type: Number,
      default: 300,
    },
  },
  watch: {
    value(data) {
      if (data) {
        this.date = new Date(data);
      } else {
        this.date = "";
      }
    },
  },
  data() {
    return {
      languages: lang,
      date: "",
      masks: {
        input: this.format,
        title: "YYYY년 MMMM",
      },
      debounceTimer: null,
    };
  },

  created() {
    this.date = new Date(this.value);
    this.div = this.division;
  },

  methods: {
    updateDate() {
      this.$emit("input", new Date(this.date).format("yyyy-MM-dd"));
      this.$emit("change", this.date);
    },
    temp() {},
    clickXIcon() {
      this.date = "";
      this.$emit("input", "");
      this.$emit("change", "");
    },
    /**
     * vs-input 컴포넌트에 입력된 값을 처리합니다.
     */
    handleInput(inputValue) {
      const parsedDate = Date.parse(inputValue);
      if (!isNaN(parsedDate)) {
        this.date = new Date(parsedDate);
        this.$emit("input", inputValue);
        this.$emit("change", this.date);
      } else {
        this.$emit("input", this.date);
        this.$emit("change", this.date);
      }

      this.$refs.datePicker.move(this.date);
    },
    debouncedHandleInput(inputValue) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.handleInput(inputValue);
      }, this.debounceMs);
    },
    onFocusout () {
      this.$emit('focusout');
    }
  },
};
</script>

<style lang="scss" scoped>
.right-icon {
  font-size: 24px;
  padding: 6px;
}
.none-readonly-input::v-deep {
  input {
    background: white;
  }
}

.datePicker::v-deep {
  .vc-popover-content-wrapper.is-interactive {
    z-index: 999;
  }
}
</style>

<style>
.vc-popover-content-wrapper.is-interactive {
  z-index: 999 !important;
}
</style>
